import axios from "axios";
import { useState } from "react";

export default function OtpPopUp({ setShowOtpPopup, email }) {

    const [otp, setOtp] = useState("");

    const handleVerify = async () => {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/verify/otp`, {
            email: email,
            otp: otp
        });

        if (response.status === 200) {
            alert("OTP Verified Successfully");
            setTimeout(() => {
                setShowOtpPopup(false);
            }, 1000);
        }
        else {
            alert("Invalid OTP");
        }
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-300">
                <h2 className="text-2xl font-medium	 mb-4">Enter OTP To Verify</h2>
                <input
                    type="text"
                    value={otp || ""} 
                    onChange={(e) => setOtp(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md mb-4"
                    placeholder="Enter OTP"
                />
                <div className="flex justify-between">
                    <button
                        className="bg-gray-300 text-red-400 px-4 py-2 rounded-md hover:shadow-custom border border-transparent hover:border-black "
                        onClick={() => setShowOtpPopup(false)}
                    >
                        Cancel
                    </button>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:shadow-custom border border-transparent hover:border-black "
                        onClick={handleVerify}
                    >
                        Verify
                    </button>
                </div>
            </div>
        </div>
    )
}
